import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-146ae13c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["placeholder", "disabled", "value", "aria-labelledby", "aria-expanded"]
const _hoisted_3 = {
  key: 0,
  id: "searchResults"
}

import { Ref, computed, ref } from 'vue';
import { Skeletor } from 'vue-skeletor';
import 'vue-skeletor/dist/vue-skeletor.css';
import { directive as vClickOutside } from 'click-outside-vue3';
import { useI18n } from 'vue-i18n';
import { RecentOrSuggestedSearchEntry, RouteDetail } from '../../types';
import { filterRoutesBySearchTerm, formatRouteFromPorts } from '../../helpers';
import { mapRouteDetailToRecentSearch } from '../../maps';
import { RecentSearches } from '../../Molecules';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteSearch',
  props: {
    routeDetail: {},
    searchLabelId: {},
    isLoading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    selectedTextCode: {},
    isError: { type: Boolean, default: false }
  },
  emits: ["routeSelected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const searchText = ref('');
const showSelectedValue = ref(true);

const searchInput: Ref<HTMLElement | null> = ref(null);

const searchResults: Ref<RecentOrSuggestedSearchEntry[]> = computed(() => {
  const filtered = filterRoutesBySearchTerm({
    routes: props.routeDetail,
    searchTerm: searchText.value,
  });
  return filtered.map(mapRouteDetailToRecentSearch);
});

const selectedRoutePorts = computed(() => {
  if (props.selectedTextCode) {
    return props.routeDetail.find(
      (route) => route.textCode === props.selectedTextCode,
    )?.ports || [];
  }
  return [];
});

const selectedText = computed(() =>
  formatRouteFromPorts({
    ports: selectedRoutePorts.value,
    textCode: props.selectedTextCode || '',
    textCodePrefix: t('Text code'),
  }));

const inputText = computed(() => {
  if (!showSelectedValue.value) {
    return searchText.value;
  }
  return selectedText.value;
});

const handleSearchTextChanged = (event: Event) => {
  searchText.value = (event?.target as HTMLInputElement)?.value || '';
};

const handleSearchInputFocus = () => {
  showSelectedValue.value = false;
};

const handleBlur = () => {
  showSelectedValue.value = true;
};

const handleSelected = (value: RecentOrSuggestedSearchEntry) => {
  searchText.value = '';
  emit('routeSelected', value.textCode || '');
  showSelectedValue.value = true;
};


return (_ctx: any,_cache: any) => {
  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_unref(Skeletor), {
        key: 0,
        height: "50"
      }))
    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
          id: "search-route",
          ref_key: "searchInput",
          ref: searchInput,
          role: "combobox",
          type: "text",
          name: "search-route",
          "aria-controls": "searchResults",
          "aria-haspopup": "listbox",
          class: _normalizeClass(["routeSearch", { 'error': _ctx.isError}]),
          placeholder: _ctx.$t('Select a route'),
          disabled: _ctx.disabled,
          value: inputText.value,
          "aria-labelledby": _ctx.searchLabelId,
          "aria-expanded": !showSelectedValue.value,
          onInput: handleSearchTextChanged,
          onFocus: handleSearchInputFocus
        }, null, 42, _hoisted_2),
        (!showSelectedValue.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(RecentSearches), {
                "show-searches": true,
                searches: searchResults.value,
                "show-port-codes": true,
                "show-text-code": true,
                "no-results-text": _ctx.$t('No suggestions found'),
                onSetSearchValue: handleSelected
              }, null, 8, ["searches", "no-results-text"])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_unref(vClickOutside), handleBlur]
      ])
}
}

})